import React from "react";
import { MapPin } from "lucide-react";

const MapSection = () => {
  return (
    <div className="w-full px-4 py-10 sm:py-16 sm:px-8 lg:px-20 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col items-center mb-10">
          <p className="text-xs font-bold tracking-[0.22em] font-krona uppercase text-gray-500 border-b-2 border-red-600 pb-0.5 mb-3">
            FIND US
          </p>
          <h2 className="text-2xl md:text-4xl lg:text-[45px] font-krona font-bold text-gray-900 tracking-wider">
            Our Location
          </h2>
        </div>

        {/* Address bar */}
        <div className="flex items-center gap-2 mb-6 justify-center">
          <MapPin size={16} className="text-red-500 flex-shrink-0" />
          <span className="text-sm text-gray-500 font-medium">
            AH45, Shreekhetra Vihar, Khandagiri, Odisha 751019
          </span>
        </div>

        {/* Map container */}
        <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-100 w-full">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d29950.003992534374!2d85.8161152!3d20.2276864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3a19a7f529d27a4f%3A0xe51176ce689dbf08!2sPrudence%20India%20Mega%20Projects%20Pvt%20Ltd%2C%20AH45%2C%20near%20Axis%20Bank%2C%20Shreekhetra%20Vihar%2C%20Khandagiri%2C%20Bhubaneswar%2C%20Odisha%20751019!3m2!1d20.2528896!2d85.7851781!5e0!3m2!1sen!2sin!4v1776072662905!5m2!1sen!2sin"
            title="Our Location"
            width="100%"
            height="500"
            style={{ border: 0, display: "block" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            className="w-full h-[500px]"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default MapSection;
